<div class="ds-modal ds-modal--auto">
    <header class="ds-modal__head">
        <span class="ds-modal__head-icon material-icons">fact_check</span>
        <div>
            <h2>{{ idioma | translate: "form.CONFIRMAR-DATOS" | async | uppercase }}</h2>
            <p>Revisá la información antes de guardar los cambios del afiliado.</p>
        </div>
    </header>

    <div class="ds-modal__body">
        <div class="ds-card confirmar-section">
            <div class="ds-section__head">
                <span class="material-icons">person</span>
                Información básica
            </div>
            <div class="ds-section__body">
                <div class="ds-summary ds-summary--grid">
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">{{ idioma | translate: "form.NOMBRE" | async }}</span>
                        <span class="ds-summary__value">{{ data?.nombrePersona || '—' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">{{ idioma | translate: "form.APELLIDO" | async }}</span>
                        <span class="ds-summary__value">{{ data?.apellidoPersona || '—' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">{{ idioma | translate: "form.TIPO-ID" | async }}</span>
                        <span class="ds-summary__value">{{ tipoIdentificacionTexto }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">{{ idioma | translate: "form.NRO-ID" | async }}</span>
                        <span class="ds-summary__value">{{ data?.identificacion || '—' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">{{ idioma | translate: "form.FECHA-NACIMIENTO" | async }}</span>
                        <span class="ds-summary__value">{{ birth || '—' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">{{ idioma | translate: "form.PAIS-NACIMIENTO" | async }}</span>
                        <span class="ds-summary__value">{{ data?.paisNacimiento?.name_es || '—' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">{{ idioma | translate: "form.CODIGO-AREA" | async }}</span>
                        <span class="ds-summary__value">{{ data?.paisCodeArea || '—' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">{{ idioma | translate: "form.NUMERO-TELEFONO" | async }}</span>
                        <span class="ds-summary__value">{{ data?.telefono || '—' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Sede seleccionada</span>
                        <span class="ds-summary__value">{{ sedeSelecionada || '—' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Plan seleccionado</span>
                        <span class="ds-summary__value">{{ planSelecionado || '—' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Empresa seleccionada</span>
                        <span class="ds-summary__value">{{ empresaSelecionada || '—' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="ds-card confirmar-section">
            <div class="ds-section__head">
                <span class="material-icons">event</span>
                Gestión
            </div>
            <div class="ds-section__body">
                <div class="ds-summary ds-summary--grid">
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Estado</span>
                        <span class="ds-summary__value">{{ data?.signoGestion?.estado || '—' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Fecha de vigencia</span>
                        <span class="ds-summary__value">{{ safeDate(data?.signoGestion?.fechaVigencia) }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Fecha de baja</span>
                        <span class="ds-summary__value">{{ safeDate(data?.signoGestion?.fechaBaja) }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Fecha de cobertura</span>
                        <span class="ds-summary__value">{{ safeDate(data?.signoGestion?.fechaCobertura) }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">PMI</span>
                        <span class="ds-summary__value">{{ data?.signoGestion?.pmi ? 'Sí' : 'No' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Vencimiento PMI</span>
                        <span class="ds-summary__value">{{ safeDate(data?.signoGestion?.fechaVtoPmi) }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Discapacidad</span>
                        <span class="ds-summary__value">{{ data?.signoGestion?.discapacidad ? 'Sí' : 'No' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Vencimiento discapacidad</span>
                        <span class="ds-summary__value">{{ safeDate(data?.signoGestion?.fechaVtoDiscapacidad) }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Otras cronicidades</span>
                        <span class="ds-summary__value">{{ data?.signoGestion?.otrasCronicidades ? 'Sí' : 'No' }}</span>
                    </div>
                    <div class="ds-summary__row">
                        <span class="ds-summary__key">Vencimiento otras cronicidades</span>
                        <span class="ds-summary__value">{{ safeDate(data?.signoGestion?.fechaVtoOtrasCronicidades) }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="ds-card confirmar-section confirmar-section--reinscripcion">
            <div class="ds-section__head">
                <span class="material-icons">restart_alt</span>
                Reinscripción O.S.
            </div>
            <div class="ds-section__body">
                <div class="confirmar-reinscripcion">
                    <span
                        class="ds-chip"
                        [ngClass]="data?.reinscripcionOs ? 'ds-chip--aprobado' : 'ds-chip--neutro'"
                    >
                        {{ data?.reinscripcionOs ? 'HABILITADA' : 'DESHABILITADA' }}
                    </span>
                    <p class="confirmar-reinscripcion__hint">
                        {{
                            data?.reinscripcionOs
                                ? 'La persona podrá iniciar una nueva inscripción desde la web con su mismo email. El permiso se apaga al aprobar la solicitud.'
                                : 'La persona no podrá iniciar una nueva inscripción desde la web.'
                        }}
                    </p>
                </div>
            </div>
        </div>
    </div>

    <footer class="ds-modal__actions">
        <button type="button" class="ds-pill ds-pill--ghost" (click)="cancelar()">
            <span class="material-icons">close</span>
            {{ idioma | translate: "form.BTN-CANCELAR" | async }}
        </button>
        <button type="button" class="ds-pill ds-pill--primary" (click)="aceptar()">
            <span class="material-icons">check</span>
            {{ idioma | translate: "form.BTN-ACEPTAR" | async }}
        </button>
    </footer>
</div>
